module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-thread panel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thread),
      expression: "thread"
    }],
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "thread-title flex-full"
  }, [(!_vm.editingTitle && _vm.thread) ? _c('h1', [_vm._v("\n                    " + _vm._s(_vm.thread.title) + "\n                    "), (_vm.canEditThread) ? _c('button', {
    attrs: {
      "title": "Edit title"
    },
    on: {
      "click": function($event) {
        _vm.editTitle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), (_vm.canStickThread) ? _c('button', {
    class: {
      'accent-sticky': _vm.thread.sticky
    },
    attrs: {
      "disabled": _vm.editingSticky_saving,
      "title": !_vm.thread.sticky ? 'Stick thread' : 'Unstick thread'
    },
    on: {
      "click": function($event) {
        _vm.toggleSticky()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editingTitle) ? _c('div', [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editingTitle_value),
      expression: "editingTitle_value"
    }],
    ref: "titleInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.editingTitle_saving
    },
    domProps: {
      "value": (_vm.editingTitle_value)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.saveTitle()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editingTitle_value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Save title",
      "disabled": _vm.editingTitle_saving
    },
    on: {
      "click": function($event) {
        _vm.saveTitle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "action-bar flex-none"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.searchUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "thread-category"
  }, [(!_vm.editingCategory && _vm.threadCategory) ? _c('div', [_c('router-link', {
    attrs: {
      "to": _vm.homeUrl
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.threadCategoryUrl
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.threadCategory.label) + "\n                ")]), _vm._v(" "), (_vm.canEditThread) ? _c('button', {
    attrs: {
      "title": "Edit category"
    },
    on: {
      "click": function($event) {
        _vm.editCategory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editingCategory) ? _c('div', [_c('DropdownSelect', {
    attrs: {
      "disabled": _vm.editingCategory_saving,
      "options": _vm.categoryOptions
    },
    model: {
      value: (_vm.editingCategory_value),
      callback: function($$v) {
        _vm.editingCategory_value = $$v
      },
      expression: "editingCategory_value"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Save category",
      "disabled": _vm.editingCategory_saving
    },
    on: {
      "click": function($event) {
        _vm.saveCategory()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "discussion"
  }, [_c('div', {
    staticClass: "posts-column"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCurrentPostWindow),
      expression: "showCurrentPostWindow"
    }]
  }, [_c('LoaderBefore', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoaderBefore),
      expression: "showLoaderBefore"
    }]
  }), _vm._v(" "), (!_vm.loading_initial) ? _c('ForumPostList', {
    ref: "postList",
    attrs: {
      "thread": _vm.threadWrapper,
      "postStore": _vm.postStore,
      "postWindow": _vm.currentPostWindow,
      "currentUser": _vm.currentUser
    },
    on: {
      "create-post": function($event) {
        _vm.createPost($event)
      },
      "update-post": function($event) {
        _vm.updatePost($event)
      },
      "like-post": function($event) {
        _vm.likePost($event)
      },
      "unlike-post": function($event) {
        _vm.unlikePost($event)
      },
      "delete-post": function($event) {
        _vm.deletePost($event)
      },
      "update-thread": function($event) {
        _vm.updateThread($event)
      },
      "solve-thread": function($event) {
        _vm.solveThread($event)
      },
      "unsolve-thread": function($event) {
        _vm.unsolveThread($event)
      },
      "go-post": function($event) {
        _vm.goToPost($event)
      },
      "view-post": function($event) {
        _vm.viewPost($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('LoaderAfter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoaderAfter),
      expression: "showLoaderAfter"
    }]
  })], 1), _vm._v(" "), _c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pre-timeline-spacer flex-full"
  }), _vm._v(" "), _c('ForumThreadTimeline', {
    ref: "timeline",
    attrs: {
      "sticky": "true",
      "stayInParent": "true",
      "stickyPadding": _vm.timeline_screenTopPad,
      "value": _vm.timelineValue,
      "startDate": _vm.threadWrapper.firstDate,
      "lastDate": _vm.threadWrapper.lastDate,
      "posts": _vm.timelinePosts
    },
    on: {
      "input": function($event) {
        _vm.setTimelineValue($event)
      },
      "thumbgrab": function($event) {
        _vm.onTimelineGrab()
      },
      "thumbrelease": function($event) {
        _vm.onTimelineRelease()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "thread-reply"
  }, [(_vm.threadReply) ? _c('ForumPost', {
    ref: "threadReply",
    staticClass: "thread-reply",
    attrs: {
      "post": _vm.threadReply,
      "isEditing": true
    },
    on: {
      "cancel": function($event) {
        _vm.cancelThreadReply()
      },
      "save": function($event) {
        _vm.saveThreadReply($event)
      }
    }
  }, [_c('template', {
    attrs: {
      "slot": "saveEditorLabel"
    },
    slot: "saveEditorLabel"
  }, [_vm._v("\n                    Post reply\n                ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-reply-spacer"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('button', {
    class: _vm.threadReplyBtnClasses,
    on: {
      "click": function($event) {
        _vm.initThreadReply()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v("\n                Reply\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "link-share-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      'accent-hover': _vm.linkShareShowing
    },
    on: {
      "click": function($event) {
        _vm.toggleLinkShare()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v("\n                    Share\n                ")]), _vm._v(" "), _c('ForumShare', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linkShareShowing),
      expression: "linkShareShowing"
    }],
    ref: "linkShare",
    attrs: {
      "value": _vm.threadUrl
    },
    on: {
      "close": function($event) {
        _vm.closeLinkShare()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.showRelatedThreads) ? _c('div', [_c('h2', [_vm._v("Related Threads")]), _vm._v(" "), _c('ForumThreadList', {
    attrs: {
      "threads": _vm.relatedThreads
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "see-more-link"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.seeMoreUrl
    }
  }, [_vm._v("\n                    View All\n                ")])], 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.thread && !_vm.threadNotFound) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('Loader')], 1) : _vm._e(), _vm._v(" "), (_vm.threadNotFound) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('ForumThreadNotFound')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-725887d1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumThread.vue
// module id = 2077
// module chunks = 2